(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jb-external-image-fallback"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.jbExternalImagesReady) return;
    window.jbExternalImagesReady = true;

    const addProductImage = (marker) => {
        const root = document.getElementById(`ProductPage-${marker.dataset.jbSectionId}`);
        if (!root || root.querySelector('.jb-external-product-media')) return;

        const info = root.querySelector('.product-info-wrap-content');
        if (!info) return;

        const media = document.createElement('div');
        media.className = 'product-media-gallery-wrap jb-external-product-media';
        const wrapper = document.createElement('div');
        wrapper.className = 'product-media-wrapper';
        const mainWrapper = document.createElement('div');
        mainWrapper.className = 'product-media-main-wrapper';
        const main = document.createElement('div');
        main.className = 'product-media-main product-media is-active';
        const ratio = document.createElement('div');
        ratio.className = 'aspect-ratio';
        ratio.style.setProperty('--ratio-percent', '100%');
        const image = document.createElement('img');
        image.src = marker.dataset.jbImageSrc;
        image.alt = marker.dataset.jbImageAlt || '';
        image.loading = 'eager';
        image.width = 1200;
        image.height = 1200;

        ratio.appendChild(image);
        main.appendChild(ratio);
        mainWrapper.appendChild(main);
        wrapper.appendChild(mainWrapper);
        media.appendChild(wrapper);
        root.classList.remove('product-no-media');
        root.insertBefore(media, info);
    };

    const addCardImage = (marker) => {
        const scope = marker.parentElement || document;
        const selector = `product-card[data-product-id="${marker.dataset.jbProductId}"]`;
        const card = scope.querySelector(selector) || document.querySelector(selector);
        if (!card) return;

        const link = card.querySelector('figure.card-media a.js-product-link');
        if (!link || link.querySelector('img')) return;

        const image = document.createElement('img');
        image.className = 'jb-external-card-image';
        image.src = marker.dataset.jbImageSrc;
        image.alt = marker.dataset.jbImageAlt || '';
        image.loading = 'lazy';
        image.width = 600;
        image.height = 600;
        link.appendChild(image);
        card.classList.remove('card-no-media');
        card.classList.add('jb-has-external-media');
    };

    const applyImages = (root = document) => {
        if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
        const markers = root.matches?.('.jb-external-image-marker')
          ? [root]
          : root.querySelectorAll?.('.jb-external-image-marker') || [];

        markers.forEach((marker) => {
          if (marker.dataset.jbExternalContext === 'product') addProductImage(marker);
          if (marker.dataset.jbExternalContext === 'card') addCardImage(marker);
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => applyImages(), { once: true });
    } else {
      applyImages();
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => applyImages(node));
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
